//Edu homepage teksten — alleen de strings 'bovenin' op de registratiepagina.
//Worden vervangen zodra Sascha de definitieve teksten aanlevert.
//
//UI-strings binnen het formulier (labels, foutmeldingen, knoppen) gaan via
//t() en worden in het admin-vertaalpaneel beheerd, niet hier.
//
//Per veld: { nl: '...', en: '...' }. De component leest met
//`eduTexts.step1.X[lang]` waarbij lang = 'nl' of 'en'.

const eduTexts = {
  step1: {
    welcomeTitle: {
      nl: 'Welkom bij het MoodLift educatieplatform',
      en: 'Welcome to the MoodLift education platform',
    },
    welcomeIntro: {
      nl: 'Hier kun je een programma volgen als onderdeel van jouw opleiding. <br />Wil je daarnaast met je welzijn aan de slag? Schrijf je dan in via <a href="https://moodlift.nl">ons gewone platform</a> en doe een programma naar keuze met ondersteuning van een persoonlijke coach (gratis!)',
      en: 'Here you can follow a program as part of your education. <br />Do you also want to work on your well-being? Then register via <a href="https://moodlift.nl">our regular platform</a> and take a program of your choice with the support of a personal coach (free!)',
    },
    programmesTitle: {
      nl: 'Onze programma\'s',
      en: 'Our programmes',
    },
  },
};

export default eduTexts;
